import type { FaireProductEntity } from "../../entity_types/product";

export const p_v4e76f8xax: FaireProductEntity = {
  token: "p_v4e76f8xax",
  type: "product",
  name: "Furry Sheep 3D Jacquard Sweater Knit Baby Jumpsuit (Organic)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/7053cb6aa800e35a26d969698de450aec753e73efb86450167fbdd9c7d25f3d0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/150fb0706596273ffb7327cdb1dc3a99a3d60ec37ff0a793ae5137ac99eed12f.png",
  ],
  priceDollars: 26,
  description:
    "Cozy and whimsical, this baby sweater knit jumpsuit features fuzzy 3D jacquard sheep motifs scattered throughout a soft grey knit. Made from breathable organic cotton, it’s finished with long sleeves and three shoulder buttons for easy dressing and all-day comfort.\n\n100% organic cotton baby sweater with applique, embroidery & jacquard design.\n\n• Breathable organic cotton, comfy and cozy.\n• Eco-friendly, chemical free and non-toxic, good for baby's delicate skin.\n• Machine washable, durable and long lasting.\n• Eco-friendly, chemical free, non-toxic, pure, natural & organic baby clothes.\n• Ethically produced in India, supporting better livelihoods for small grower farmers.\n\nViverano, an American brand, was founded in 2013 with the simple idea of producing eco-friendly, pure and organic baby clothes. Viverano baby clothing is known for its soft hand feel and high quality. Pamper your precious babies with our non-toxic, lightweight, all-season, natural baby outfits.\n\nExperience 'Organic Comfort' by Viverano, a family-owned small business.",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:29.747Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
